import ModalGeneric from "./ModalGeneric";

// modal to show that user needs to install metamask
export default function ModalConfirm({title, message, description, callback, className}) {

    function closeButton(){
        if(callback) callback(null);
    }

	return (
        <ModalGeneric title={title || "Are You Sure?"} callback={closeButton} className={className}>
            <div className="flex items-center justify-between flex-col">
                <p className="text-xl p-4">{message}</p>
				{description && <p className="text-lg font-light my-4">{description}</p>}
				<div className="flex justify-center w-full">
					<button className="btn w-full m-4 shadow-lg py-3 px-12 uppercase" 
						onClick={() => callback(true)}>
						Yes
					</button>
					<button className="btn w-full m-4 shadow-lg py-3 px-12 uppercase" 
						onClick={() => callback(false)}>
						No
					</button>
				</div>
			</div>
        </ModalGeneric>
	);
}